import { UserV1 } from '@/shared/api';

export function isPremiumUser(user: UserV1 | null): boolean {
	return (
		!!user?.subscriptionId || ['admin', 'editor'].includes(user?.role || '')
	);
}
